var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.7123 4.2c-1.0558 0-1.9125.8567-1.9125 1.9125 0 .6017.2829 1.1674.765 1.53l8.67 6.5025a1.279 1.279 0 0 0 1.53 0l8.67-6.5025a1.914 1.914 0 0 0 .765-1.53c0-1.0558-.8566-1.9125-1.9125-1.9125zM1.7998 8.6625V16.95c0 1.4065 1.1435 2.55 2.55 2.55h15.3c1.4065 0 2.55-1.1435 2.55-2.55V8.6625l-8.67 6.5025a2.546 2.546 0 0 1-3.06 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-icon.c612f709a619ba70304a1a529d754968.svg";